import { SupportedTagEntityTypes, Tag, TagRelation } from '../../store/Tags';
import { callExternalApi } from '../callExternalApi';

export const getTags = async (accountIds?: string[]) => {
  if (!accountIds?.length) return { data: null, error: { message: 'Must provide account IDs to fetch tags' } };
  return await callExternalApi<Tag[]>({
    url: `api/tags?account_ids=${accountIds.join(',')}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const postTag = async (tag: Omit<Tag, 'id' | 'accountId'>, accountId?: string) => {
  return await callExternalApi<Tag>({
    url: 'api/tags',
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      ...(accountId ? { AccountScope: accountId } : {})
    },
    data: tag
  });
};

export const putTag = async (tag: Omit<Tag, 'accountId'>, accountId?: string) => {
  return await callExternalApi<Tag>({
    url: `api/tags/${tag.id}`,
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
      ...(accountId ? { AccountScope: accountId } : {})
    },
    data: tag
  });
};

export const deleteTag = async (id: string) => {
  return await callExternalApi<void>({
    url: `api/tags/${id}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const postTagRelation = async (tagId: string, entityId: string, entityType: SupportedTagEntityTypes) => {
  return await callExternalApi<TagRelation>({
    url: `api/tags/${tagId}/add_relation`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: {
      entity_id: entityId,
      entity_type: entityType
    }
  });
};

export const deleteTagRelation = async (tagId: string, entityId: string, entityType: SupportedTagEntityTypes) => {
  return await callExternalApi<void>({
    url: `api/tags/${tagId}/remove_relation/entity_id/${entityId}/entity_type/${entityType}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};
